import styled, { css } from "styled-components";
import { CarouselHeaderSlider } from "../../styled.js";
export const CarouselHeaderDesktopSlider = styled(CarouselHeaderSlider).withConfig({
    displayName: "styled__CarouselHeaderDesktopSlider",
    componentId: "sc-40f01149-0"
})`
	${({ $uniqueImage  })=>$uniqueImage && css`
			.splide__arrows {
				.splide__arrow {
					z-index: 1;
					font-size: 52px;
					background-color: ${({ theme  })=>theme.colors.white.lower};
					color: ${({ theme  })=>theme.colors.primary.base};
					height: 84px;
					width: 64px;

					&.splide__arrow--prev {
						border-radius: 0 ${({ theme  })=>theme.border.radius.rounded}
							${({ theme  })=>theme.border.radius.rounded} 0;
						left: 0;
					}

					&.splide__arrow--next {
						border-radius: ${({ theme  })=>theme.border.radius.rounded} 0 0
							${({ theme  })=>theme.border.radius.rounded};
						right: 0;
					}
				}
			}
		`}
`;

//# sourceMappingURL=styled.js.map